import React from "react";
import classNames from "classnames";
import styles from "./index.module.css";

export interface ButtonProps {
  id?: string;
  type?:
    | "primary"
    | "secondary"
    | "primary-outline"
    | "secondary-outline"
    | "ghost"
    | "text";
  size?: "xs" | "sm" | "md" | "lg" | "xl" | "full";
  disabled?: boolean;
  className?: string;
  onClick?: (clickParam: any) => void;
  children: React.ReactNode;
  style?: React.CSSProperties;
  stretch?: boolean;
}

export const Button = ({
  id,
  type,
  size,
  disabled,
  className,
  onClick,
  children,
  style,
  stretch = false,
  ...rest
}: ButtonProps) => {
  const propsClass = {
    [styles.buttonPrimary]: type === "primary",
    [styles.buttonSecondary]: type === "secondary",
    [styles.buttonPrimaryOutline]: type === "primary-outline",
    [styles.buttonSecondaryOutline]: type === "secondary-outline",
    [styles.buttonGhost]: type === "ghost",
    [styles.buttonText]: type === "text",
    [styles.buttonDisabled]: disabled,
    [styles.buttonXtraSmall]: size === "xs",
    [styles.buttonSmall]: size === "sm",
    [styles.buttonMedium]: size === "md",
    [styles.buttonLarge]: size === "lg",
    [styles.buttonBig]: size === "xl",
    [styles.buttonFull]: size === "full" || stretch,
  };

  const handleClick = (clickParam) => {
    if (disabled) {
      return;
    }

    onClick(clickParam);
  };

  return (
    <button
      id={id}
      className={classNames(styles.button, propsClass, className)}
      style={style}
      onClick={handleClick}
      type="button"
      disabled={disabled}
      {...rest}
    >
      {children}
    </button>
  );
};

Button.defaultProps = {
  id: null,
  type: "primary",
  disabled: false,
  size: "md",
  onClick: () => {},
};
